import { Card, DatePicker, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { disableFutureDates, formatDate } from "../../services/util";
import { useQuery } from "react-query";
import { FullscreenOutlined, LoadingOutlined } from "@ant-design/icons";
import Chart from "react-google-charts";
import moment from "moment";
import HTTP from "../../services/httpService";
import { columnChartConfigurationOptions } from "../../config";

const chartConfigs = {
    ...columnChartConfigurationOptions,
    curveType: "function", // Smooths the lines
    series: {
        1: { color: "#fe8447", visibleInLegend: false },
    },
    legend: { position: "bottom" },
    hAxis: {
        slantedText: false,
        minTextSpacing: 30,
        maxAlternation: 1,
    },
    explorer: {
        actions: ["dragToZoom", "rightClickToReset"],
    },
    focusTarget: "category",
};

function DailyChart() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [chartData, setChartData] = useState([[`months`, "counts"]]);
    const [enableZoom, setEnableZoom] = useState(false);
    const [formData, setFormData] = useState({
        start_date: formatDate(new Date(new Date().getFullYear(), 0, 1)),
        end_date: formatDate(new Date()),
        chart_by: "year",
        staff_id,
    });

    const {
        status,
        data: monthlySuccessRate,
        refetch,
    } = useQuery(
        "DailyManagementChart",
        async () => {
            return await HTTP(`/dashboard/getDailySuccessRate`, {
                ...formData,
            });
        },
        {
            enabled: false,
        },
    );

    useEffect(() => {
        refetch();
    }, [formData]);

    useEffect(() => {
        if (status === "success") {
            // const avg =
            //     monthlySuccessRate?.data?.reduce((prev, cur, i) => {
            //         if (i > 0) prev = prev + Number(cur[1]);
            //         return prev;
            //     }, 0) /
            //     (monthlySuccessRate?.data?.length - 1);
            // console.log(avg);
            setChartData(
                monthlySuccessRate.data.map((e, i) => {
                    if (i == 0) return [...e, "Threshold"];
                    else return [...e, 98.15];
                }),
            );
        }
    }, [status, monthlySuccessRate]);

    return (
        <Card className="box-shadow" style={{ width: "63%" }}>
            <div className="flex space-between">
                <strong>Daily Success(%)</strong>
                <div className="flex flex-gap-10 align-center">
                    <DatePicker
                        defaultValue={moment(formData.start_date)}
                        picker="month"
                        onChange={(e) => {
                            console.log(
                                `date selection changed`,
                                e,
                                formatDate(e),
                                formatDate(moment(e).endOf("month")),
                            );
                            setFormData({
                                ...formData,
                                start_date: formatDate(e),
                                end_date: formatDate(moment(e).endOf("month")),
                            });
                        }}
                        allowClear={false}
                        disabledDate={disableFutureDates}
                        format="MM/YYYY"
                        ranges={{
                            "Last 7 Days": [
                                moment().subtract(7, "day"),
                                moment(),
                            ],
                            "Last 30 Days": [
                                moment().subtract(29, "day"),
                                moment(),
                            ],
                            "Current Month": [
                                moment().startOf("month"),
                                moment(),
                            ],
                            "Last Month": [
                                moment().subtract(1, "month").startOf("month"),
                                moment().subtract(1, "month").endOf("month"),
                            ],
                            "Last 3 Month": [
                                moment().subtract(3, "month"),
                                moment(),
                            ],
                        }}
                    />
                    <FullscreenOutlined
                        style={{ fontSize: "20px" }}
                        onClick={() => {
                            setEnableZoom(true);
                        }}
                    />
                </div>
            </div>
            {status == "success" ? (
                <Chart
                    chartType="LineChart"
                    data={chartData}
                    options={{
                        ...chartConfigs,
                        width: 700,
                        height: 500,
                    }}
                />
            ) : (
                <Spin
                    indicator={
                        <LoadingOutlined style={{ fontSize: 48 }} spin />
                    }
                />
            )}
            <Modal
                open={enableZoom}
                destroyOnClose
                onCancel={() => {
                    setEnableZoom(false);
                }}
                width={"fit-content"}
                height={"fit-content"}
                footer={""}
            >
                <Chart
                    chartType="LineChart"
                    data={chartData}
                    options={{
                        ...chartConfigs,
                        title: "Daily Success(%)",
                        width: "80vw",
                        height: "70vh",
                    }}
                />
            </Modal>
        </Card>
    );
}

export default DailyChart;
